export class DateUtil {
    /**
     * Trims SQL datetimeoffset fractional seconds to milliseconds so `Date.parse` accepts the value.
     */
    public static toParseableIso(value: string): string {
        return value.replace(/(\.\d{3})\d+/, '$1')
    }

    /**
     * Converts a string representation of a date to a @see:Date object, using the specified time zone offset information of the string to ensure
     * that the new Date will display as intended for that time zone.
     */
    public static toDate(date: any): Date | null {
        if (!date) return null
        const value = typeof date === 'string' ? DateUtil.toParseableIso(date) : date
        return new Date(value)
    }

    /** Numeric timestamp for sorting, 0 if the value cannot be parsed. */
    public static toTimestamp(date: any): number {
        const parsed = DateUtil.toDate(date)
        if (!parsed) return 0
        const time = parsed.getTime()
        return isNaN(time) ? 0 : time
    }

    public static toDuration(startDate: Date, endDate: Date): number {
        const start = new Date(startDate)
        const finish = new Date(endDate)
        return Math.abs(finish.getTime() - start.getTime()) / 36e5
    }

    public static toDays(startDate: Date, endDate: Date): number {
        const start = new Date(startDate)
        const finish = new Date(endDate)
        const difference = Math.abs(finish.getTime() - start.getTime())
        return Math.round(difference / (1000 * 3600 * 24))
    }

    public static toShortDate(date: Date): string {
        return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear()
    }
}
